import { render, staticRenderFns } from "./DashboardPanel2021.vue?vue&type=template&id=9a0e599c&scoped=true&"
import script from "./DashboardPanel2021.vue?vue&type=script&lang=js&"
export * from "./DashboardPanel2021.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPanel2021.vue?vue&type=style&index=0&id=9a0e599c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0e599c",
  null
  
)

export default component.exports